<template>
  <div class="record">
    <backHeader back-addr="/person"></backHeader>
    <div style="text-align:center;padding:10px;">{{$store.state.mineStore.userName}}--登录记录(最近100条记录)</div>
    <ul>
      <li v-for="item in record" style="text-align:center;color:gray;font-size:15px;background:white;"><span style="line-height:40px;font-size:14px;">{{item}}</span><crossLine></crossLine></li>
    </ul>
  </div>
</template>
<script>
import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";
import logApi from "../api/users";
import { MessageBox, Toast } from "mint-ui";
import axios from "axios";
import Qs from "qs";
import Addr from "./../utils/getAPI";
import store from "@/store/index";

export default {
  name: "record",
  data() {
    return {
      record: []
    };
  },
  methods: {
    //获取登录记录
    initRecord() {
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "user/record?userNumber=" +
            this.$store.state.mineStore.userNumber
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            this.record = res.data.returnData;
          } else {
            Toast({
              message: res.data.returnMsg,
              position: "bottom",
              duration: 800
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {},
  mounted: function() {
    //获取登录记录
    this.initRecord();
  },
  components: { backHeader, crossLine }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.record {
  .cross-line {
    height: 1px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/module-data/record.vue